module.exports = __webpack_public_path__ + "static/img/180153_1.98eefed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_1.jpg
// module id = MO7t
// module chunks = 1